// extracted by mini-css-extract-plugin
export default {"wrapper":"StatusTable_wrapper__0wCKF","active":"StatusTable_active__XjcyM","wait":"StatusTable_wait__j1CxT","progress":"StatusTable_progress__6+8+P"};